import { useMemo, useState } from "react";
import {
  ContentTypeRender,
  SelectInput,
  useRouterQueryStore,
  Wrapper,
} from "nystem-components";

const getDate = (year, month, day) => new Date(year, month, day).getTime();

const DateShortcuts = ({ model, path, view }) => {
  const [from] = useRouterQueryStore(model.saveIdFrom, "int");
  const [to] = useRouterQueryStore(model.saveIdTo, "int");
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  const ranges = useMemo(
    () => [
      {
        _id: "last7days",
        text: "Last 7 days",
        from: getDate(year, month, day - 6),
        to: getDate(year, month, day),
      },
      {
        _id: "last30days",
        text: "Last 30 days",
        from: getDate(year, month, day - 29),
        to: getDate(year, month, day),
      },
      {
        _id: "thismonth",
        text: "This month",
        from: getDate(year, month, 1),
        to: getDate(year, month, day),
      },
      {
        _id: "lastmonth",
        text: "Last month",
        from: getDate(year, month - 1, 1),
        to: getDate(year, month, 0),
      },
      {
        _id: "thisyear",
        text: "This year",
        from: getDate(year, 0, 1),
        to: getDate(year, month, day),
      },
      {
        _id: "lastyear",
        text: "Last year",
        from: getDate(year - 1, 0, 1),
        to: getDate(year - 1, 11, 31),
      },
    ],
    [day, month, year],
  );
  const [selected, setSelected] = useState(
    ranges.find((range) => range.from === from && range.to === to)?._id,
  );

  return (
    <Wrapper>
      <SelectInput
        model={{
          ...model,
          option: [...ranges, { _id: "custom", text: "Custom range" }],
        }}
        value={selected || "custom"}
        setValue={(value) => {
          const range = ranges.find(({ _id }) => _id === value);
          setSelected(range?._id);
          if (!range) return;

          view.setValue({ path: "from", value: range.from });
          view.setValue({ path: "to", value: range.to });
        }}
      />
      <Wrapper className={selected && "hidden"}>
        <ContentTypeRender path={path} items={model.item} />
      </Wrapper>
    </Wrapper>
  );
};

export default DateShortcuts;
